import { render, staticRenderFns } from "./VideoCourse.vue?vue&type=template&id=1d4ee3f4&scoped=true"
import script from "./VideoCourse.vue?vue&type=script&lang=js"
export * from "./VideoCourse.vue?vue&type=script&lang=js"
import style0 from "./VideoCourse.vue?vue&type=style&index=0&id=1d4ee3f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4ee3f4",
  null
  
)

export default component.exports